import {
    Box, IconButton, Table, TableBody, TableCell,
    TableHead, TableRow
} from '@mui/material';
import { RHFTextField } from 'src/components/hook-form';
import { useFieldArray } from 'react-hook-form';
import Iconify from 'src/components/iconify';

export const ModuleForm = ({ control, index, removeModule, moduleCount }) => {
    const { fields, append, remove } = useFieldArray({
        control,
        name: `modules.${index}.features`
    });
    return (
        <Box
            key={ index }
            sx={ { border: '1px solid #ccc', p: 2, borderRadius: 2, mb: 3 } }
        >
            <Box display="flex" alignItems="center" mb={ 2 }>
                <RHFTextField
                    name={ `modules.${index}.module_name` }
                    label="Module Name"
                    sx={ { flexGrow: 1 } }
                />
                { moduleCount > 1 && (
                    <IconButton onClick={ () => removeModule(index) }>
                        <Iconify icon="mdi:delete" />
                    </IconButton>
                ) }
            </Box>

            <Table size="small">
                <TableHead>
                    <TableRow>
                        <TableCell>Feature Name</TableCell>
                        <TableCell>Cost</TableCell>
                        <TableCell>Actions</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    { fields.map((feature, featureIndex) => (
                        <TableRow key={ feature.id }>
                            <TableCell>
                                <RHFTextField
                                    name={ `modules.${index}.features.${featureIndex}.name` }
                                    placeholder="Enter feature name..."
                                />
                            </TableCell>
                            <TableCell>
                                <RHFTextField
                                    name={ `modules.${index}.features.${featureIndex}.cost` }
                                    placeholder="Enter cost..."
                                    type="number"
                                />
                            </TableCell>
                            <TableCell>
                                <IconButton onClick={ () => append({ name: '', cost: '' }) }>
                                    <Iconify icon="mingcute:add-line" />
                                </IconButton>
                                { fields.length > 1 && (
                                    <IconButton onClick={ () => remove(featureIndex) }>
                                        <Iconify icon="mdi:delete" />
                                    </IconButton>
                                ) }
                            </TableCell>
                        </TableRow>
                    )) }
                </TableBody>
            </Table>
        </Box>
    );
};

